import React from "react";
import { Panel } from "react-bootstrap";
import { useTranslation } from "react-i18next";

/**
 * Read-only container that visually echoes the TMS "Option Group" treatment.
 * It wraps the objectives belonging to an option group (a step where the Learner
 * only needs to complete some of the grouped objectives) so the Learner can see
 * they are part of a group. It is purely presentational — no selection logic.
 *
 * A group is satisfied either by completing a number of objectives (`numRequired`)
 * or by completing objectives totalling a number of hours (`hoursRequired`).
 */
export const LearningObjectiveGroup: React.FunctionComponent<
  React.PropsWithChildren<{
    numRequired?: number | null;
    hoursRequired?: number | null;
    total: number;
  }>
> = ({ numRequired, hoursRequired, total, children }) => {
  const { t } = useTranslation();
  const requirement =
    hoursRequired != null
      ? t("optionGroupHoursRequirement", { hoursRequired, total })
      : t("optionGroupRequirement", {
          numRequired: numRequired ?? total,
          total,
        });
  return (
    <li className="learning-path-li">
      <Panel className="learning-objective-group">
        <Panel.Heading>
          <Panel.Title componentClass="h3">{t("optionGroup")}</Panel.Title>
          <div className="learning-objective-group--requirement">
            {requirement}
          </div>
        </Panel.Heading>
        <Panel.Body>
          <ul className="learning-path-ul">{children}</ul>
        </Panel.Body>
      </Panel>
    </li>
  );
};
